import { CustomOrderItem } from '@spike/order-model';
import { FunctionComponent } from 'react';
import OrderItem from './OrderItem';

export interface CustomItemProps {
    customItem: CustomOrderItem;
    className?: string;
}

export const CustomItem: FunctionComponent<CustomItemProps> = props => {
    return (
        <OrderItem
            type="Custom"
            orderItem={props.customItem.orderItem}
            staff={props.customItem.staff}
            className={props.className}
        />
    );
};

export default CustomItem;
